import CustomExtendedDataSection from './CustomExtendedDataSection';

import SectionDetails from './SectionDetails';
import SectionMultiEnum from './SectionMultiEnum';
import SectionText from './SectionText';
import SectionYoutubeVideo from './SectionYoutubeVideo';

export { SectionDetails, SectionMultiEnum, SectionText, SectionYoutubeVideo };

export default CustomExtendedDataSection;
